module.exports = __webpack_public_path__ + "img/Ayala-Malls.18508270.png";